/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 页面终端：coupons_pc（3 个 D 位坑位，3 个 C 位模块）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const COUPONS_PC_SPM_CODES = {
  first_order_coupons: {
    code: `${sitePrefix}.coupons_pc.first_order_coupons`,
    'coupon_cta_{NN}': `${sitePrefix}.coupons_pc.first_order_coupons.coupon_cta_{NN}`,
  },
  general_coupons: {
    code: `${sitePrefix}.coupons_pc.general_coupons`,
    'coupon_cta_{NN}': `${sitePrefix}.coupons_pc.general_coupons.coupon_cta_{NN}`,
  },
  promotion: {
    code: `${sitePrefix}.coupons_pc.promotion`,
    shop_promotion: `${sitePrefix}.coupons_pc.promotion.shop_promotion`,
  },
} as const satisfies SpmPageCodes;
